import script from "./ContentWorkflowItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentWorkflowItem.vue?vue&type=script&lang=ts&setup=true"

import "./ContentWorkflowItem.vue?vue&type=style&index=0&id=68392778&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68392778"]])

export default __exports__